import { useMemo } from "react";
import type { SelectOption } from "@purpur/select";

type UsePageOptionsHook = {
  options: SelectOption[];
};

export const usePageOptions = (numberOfPages: number): UsePageOptionsHook => {
  const options = useMemo(
    () =>
      Array.from({ length: numberOfPages }, (_, i) => ({ label: `${i + 1}`, value: `${i + 1}` })),
    [numberOfPages]
  );

  return {
    options,
  };
};
